import React, { useState } from "react";
import { QueryFields } from "data/Types";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import styles from "./Utils.module.css";

const NotAvailabe = () => <abbr title="Not available">N/A</abbr>;
const NotFound = ({ items = "Items" }) => <em>No {items} found.</em>;
const Loading = () => (
  <span className="spinner-border spinner-border-sm mr-1"></span>
);

const GetFieldsList = (field, labelOnly = true) => {
  const fields = [];
  if (field & QueryFields.PatentNumber) {
    fields.push({
      key: "PatentNumber",
      name: "number",
      label: "Patent Number",
    });
  }
  if (field & QueryFields.Title) {
    fields.push({
      key: "Title",
      name: "title",
      label: "Title",
    });
  }
  if (field & QueryFields.Abstract) {
    fields.push({
      key: "Abstract",
      name: "abstract",
      label: "Abstract",
    });
  }
  if (field & QueryFields.Year) {
    fields.push({
      key: "Year",
      name: "year",
      label: "Year",
    });
  }
  if (field & QueryFields.Date) {
    fields.push({
      key: "Date",
      name: "date",
      label: "Date",
    });
  }
  if (field & QueryFields.Authors) {
    fields.push({
      key: "Authors",
      name: "authors",
      label: "Authors",
    });
  }
  if (field & QueryFields.Author) {
    fields.push({
      key: "Author",
      name: "authors.name",
      label: "Author",
    });
  }
  if (field & QueryFields.Owners) {
    fields.push({
      key: "Owners",
      name: "owners",
      label: "Owners",
    });
  }
  if (field & QueryFields.Owner) {
    fields.push({
      key: "Owner",
      name: "owners.name",
      label: "Owner",
    });
  }
  if (field & QueryFields.DataSource) {
    fields.push({
      key: "DataSource",
      name: "dataSource",
      label: "Data Source",
    });
  }
  if (field & QueryFields.Publisher) {
    fields.push({
      key: "Publisher",
      name: "publisher",
      label: "Publisher",
    });
  }
  if (field & QueryFields.FOS) {
    fields.push({
      key: "FOS",
      name: "fos",
      label: <abbr title="Fields of Science and Technology">FoS</abbr>,
    });
  }
  if (field & QueryFields.Issue) {
    fields.push({
      key: "Issue",
      name: "issue",
      label: "Issue",
    });
  }
  if (field & QueryFields.Url) {
    fields.push({
      key: "Url",
      name: "url",
      label: "Url",
    });
  }
  if (field & QueryFields.Keywords) {
    fields.push({
      key: "Keywords",
      name: "keywords",
      label: "Keywords",
    });
  }
  if (field & QueryFields.Venue) {
    fields.push({
      key: "Venue",
      name: "venue",
      label: "Venue",
    });
  }
  if (field & QueryFields.Language) {
    fields.push({
      key: "Language",
      name: "lang",
      label: "Language",
    });
  }
  if (field & QueryFields.DOI) {
    fields.push({
      key: "DOI",
      name: "doi",
      label: <abbr title="Digital Object Identifier">DOI</abbr>,
    });
  }
  if (field & QueryFields.Status) {
    fields.push({
      key: "Status",
      name: "status",
      label: "Status",
    });
  }
  if (field & QueryFields.Country) {
    fields.push({
      key: "Country",
      name: "country",
      label: "Country",
    });
  }
  if (field & QueryFields.Claims) {
    fields.push({
      key: "Claims",
      name: "claims",
      label: "Number of Claims",
    });
  }
  if (field & QueryFields.IPC) {
    fields.push({
      key: "IPC",
      name: "ipc",
      label: <abbr title="International Patent Classification">IPC</abbr>,
    });
  }
  if (field & QueryFields.CPC) {
    fields.push({
      key: "CPC",
      name: "cpc",
      label: (
        <abbr title="Cooperative Patent Classification (based on IPC)">
          CPC
        </abbr>
      ),
    });
  }
  return labelOnly ? fields.map((f) => f.label) : fields;
};

export { NotAvailabe, NotFound, Loading, GetFieldsList };

export const Select = ({
  uid = "select",
  value,
  items,
  empty = "Please choose...",
  setValue,
  allowSetEmpty = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleToggle = () => setIsOpen(!isOpen);
  return (
    <ButtonDropdown
      toggle={handleToggle}
      isOpen={isOpen}
      className={styles.dropdown}
    >
      <DropdownToggle caret color="outline-secondary" size="sm">
        {value || empty}
      </DropdownToggle>
      <DropdownMenu right>
        {allowSetEmpty && (
          <DropdownItem onClick={() => setValue(null)}>{empty}</DropdownItem>
        )}
        {items.map((item, i) => (
          <DropdownItem
            key={`${uid}-${i}`}
            onClick={() => setValue(item.name || item)}
          >
            {item.level > 1 ? "—".repeat(item.level - 1) + " " : ""}
            {item.name || item}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </ButtonDropdown>
  );
};
